import { render } from "./Definition_of_basic_measures.vue?vue&type=template&id=e24d65c4&scoped=true"
import script from "./Definition_of_basic_measures.vue?vue&type=script&lang=js"
export * from "./Definition_of_basic_measures.vue?vue&type=script&lang=js"

import "./Definition_of_basic_measures.vue?vue&type=style&index=0&id=e24d65c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24d65c4"]])

export default __exports__